import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon_calculator.png'
import _imports_1 from '@/assets/image/icon/icon_help@2x.png'
import _imports_2 from '@/assets/image/icon/icon_serve@2x.png'
import _imports_3 from '@/assets/image/icon/line_logo@2x.png'
import _imports_4 from '@/assets/image/footer/kakao_footer.png'
import _imports_5 from '@/assets/image/icon/icon_open@2x.png'
import _imports_6 from '@/assets/image/icon/icon_close@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-cf298346"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_1,
  class: "helecenterIcon"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_2
}, null, -1))
const _hoisted_4 = { style: {"margin-bottom":"0"} }
const _hoisted_5 = {
  key: 0,
  class: "badge"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_3
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "LINE", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  draggable: "false",
  src: _imports_4
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kakao", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  class: /*#__PURE__*/_normalizeClass(['tool-bar-menu'])
}

import { ref, computed, onMounted } from 'vue'
import { useRtfix, useSite2Station, isJA, isKO, isD2C, useSite, isEN } from '@/store'
import { t } from '@/plugins/i18n'
import AppLink from '@/components/common/AppLink.vue'
import { Site, lineUrl } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import CostCalc from '@/views/microapp/CostCalc.vue'
import CancelOrderTips from './CancelOrderTips.vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ProductRespDTO } from '@/service/goods'
import { calcCeil, formatMoneyDirection, showCurrentUnit } from '@/util/useYan'
import useEchart from '@/util/useEchart'
import bus from '@/util/useBus'
interface calProductRespDTO extends ProductRespDTO {
  finalProductSellPrice: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isLogin = computed(() => store.getters.isLogin)
const route: any = useRoute()
const store = useStore()
const router = useRouter()
const w: any = window
// 成本计算器
const costVisible = ref(false)

/** 点击帮助中心 */
const onClickHelpCenter = () => {
  window.location.href = '/' + useSite() + '/help'
}
console.log('route', route, route.params.id)

const getRangePriceByStation = (productSellPriceRange = '', currency = undefined) => {
  if (!String(productSellPriceRange).includes('-')) return calcCeil(productSellPriceRange, currency)
  const [start, end] = productSellPriceRange.split('-').map((v) => calcCeil(v, currency))

  return [start, end].join('-')
}

const { language, metaData, companyId } = useEchart()
const showPlugin = () => {
  const user = store.getters.user
  const customMiniChatData = { companyId, lan: language, echatTag: `web_${language}`, metaData, visEvt: '' }
  if (route.name?.toString().includes('goods_')) {
    const productCode = route.params.id
    const detail = JSON.parse(sessionStorage.getItem(`good_${productCode}`) ?? '{}') as calProductRespDTO
    // 是否是韩国仓商品
    const isMultiGoods = detail.country === 'KR' && detail.platformType === 'OL'
    const content = `<div><span style='color:#c70404;font-size:16px'>${detail?.finalProductSellPrice}${showCurrentUnit(isMultiGoods)}</span><span style='color:#999'>(${formatMoneyDirection(getRangePriceByStation(detail.finalProductSellPrice))
      })</span></div>`
    const visEvt = {
      eventId: `good_${productCode}`,
      title: detail.productTitle,
      imageUrl: detail.productMainImg,
      urlForVisitor: `http('${location.href}','blank')`,
      urlForStaff: `http('${location.href}','blank')`,
      content
    }
    console.log(visEvt, 'visEvt')

    customMiniChatData.visEvt = JSON.stringify(visEvt)
  }

  console.log(JSON.stringify(customMiniChatData), 'customMiniChat')
  window.ECHAT.customMiniChat(customMiniChatData)
}

bus.on('open-chat', showPlugin)

onMounted(() => {
  const timer = setInterval(() => {
    if (window?._echat) {
      clearInterval(timer)
      window?._echat('on', {
        // 一洽配置加载完成
        ready: function () {

        },
        // 一洽新消息数量
        newMsg: function (num: number) {
          count.value = num
        }
      })
    }
  }, 1000)
})

const showCalculator = () => {
  costVisible.value = true
}

const count = ref(0) // 客服消息未读数量

const isExpand = ref(true)
const hanldeExpend = () => {
  isExpand.value = !isExpand.value
}


return (_ctx: any,_cache: any) => {
  const _directive_drag = _resolveDirective("drag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("aside", {
      class: _normalizeClass([isExpand.value ? 'tool-bar-show' : '', 'm-tool-bar',])
    }, [
      _createElementVNode("ul", null, [
        (_unref(route).name?.indexOf('costCalcList') === -1 && _unref(route).name?.indexOf('goods_') === -1 && _unref(route).name?.indexOf('unlogin') === -1)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: "tool-bar-service",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
              onClick: _cache[1] || (_cache[1] = () => {
        // taTrack({
        //   event: TaEvent.BTN_CLICK,
        //   value: {
        //     position: 'customer_service'
        //   }
        // })
      })
            }, [
              _createElementVNode("a", {
                onClick: showCalculator,
                style: _normalizeStyle({ background: isExpand.value ? '#fff' : 'none' })
              }, [
                _hoisted_1,
                _createElementVNode("span", {
                  style: {"margin-bottom":"0"},
                  class: _normalizeClass(_unref(isEN)() ? 'font-size-calc' : '')
                }, _toDisplayString(_unref(t)('成本计算')), 3)
              ], 4)
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("li", {
          class: "tool-bar-helpCenter",
          onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
          onClick: _cache[3] || (_cache[3] = () => {
        _unref(taTrack)({
          event: _unref(TaEvent).BTN_CLICK,
          value: {
            position: 'help'
          }
        })
      })
        }, [
          _createElementVNode("a", {
            style: _normalizeStyle({ background: isExpand.value ? '#fff' : 'none' }),
            onClick: onClickHelpCenter
          }, [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('帮助')), 1)
          ], 4)
        ], 32),
        _createElementVNode("li", {
          class: "tool-bar-service",
          onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"])),
          onClick: _cache[5] || (_cache[5] = () => {
        _unref(taTrack)({
          event: _unref(TaEvent).BTN_CLICK,
          value: {
            position: 'customer_service'
          }
        })
      })
        }, [
          _createElementVNode("a", {
            onClick: showPlugin,
            style: _normalizeStyle({ background: isExpand.value ? '#fff' : 'none' })
          }, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('客服')), 1),
            (count.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true)
          ], 4)
        ], 32),
        _createElementVNode("li", {
          class: "tool-bar-line",
          onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"])),
          onClick: _cache[7] || (_cache[7] = () => {
        _unref(taTrack)({
          event: _unref(TaEvent).BTN_CLICK,
          value: {
            position: 'line'
          }
        })
      })
        }, [
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                target: "_blank",
                href: _unref(lineUrl),
                style: _normalizeStyle({ background: isExpand.value ? '#fff' : 'none' })
              }, _hoisted_9, 12, _hoisted_6))
            : _createCommentVNode("", true),
          (_unref(isKO)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                href: "https://pf.kakao.com/_uzWxoxj",
                style: _normalizeStyle({ background: isExpand.value ? '#fff' : 'none' })
              }, _hoisted_12, 4))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("li", _hoisted_13, [
          _withDirectives(_createElementVNode("img", {
            onClick: hanldeExpend,
            class: "tool-bar-icon-menu",
            referrerPolicy: "no-refer  rer",
            draggable: "false",
            src: _imports_5
          }, null, 512), [
            [_vShow, !isExpand.value]
          ]),
          _withDirectives(_createElementVNode("img", {
            onClick: hanldeExpend,
            class: "tool-bar-icon-menu",
            referrerPolicy: "no-referrer",
            draggable: "false",
            src: _imports_6
          }, null, 512), [
            [_vShow, isExpand.value]
          ])
        ])
      ]),
      (_unref(isJA)() && _unref(isLogin))
        ? (_openBlock(), _createBlock(CancelOrderTips, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2), [
      [_directive_drag]
    ]),
    _createVNode(CostCalc, {
      visible: costVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((costVisible).value = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})